// src/components/User/Home/HomePage/ContactModalDrawer.js
import React, { useEffect } from "react";
import { X } from "lucide-react";
import ContactForm from "./ContactForm";

export default function ContactModalDrawer({ isOpen, onClose }) {
    // Prevent background scrolling when open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
            {/* Backdrop / Overlay */}
            <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
                onClick={onClose}
                aria-hidden="true"
            />

            {/* Modal / Drawer Content */}
            <div
                className="relative z-10 w-full max-w-lg bg-[var(--bg-surface)] p-6 shadow-2xl transition-all duration-300 
                rounded-t-2xl sm:rounded-2xl max-h-[90vh] overflow-y-auto animate-in slide-in-from-bottom sm:zoom-in-95"
                style={{
                    backgroundColor: "var(--bg-surface)",
                    color: "var(--text-primary)",
                }}
            >
                {/* Header block with close button */}
                <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-3">
                    <div>
                        <h2 className="text-xl font-bold">Start a Conversation</h2>
                        <p className="text-xs text-[var(--text-secondary)] mt-1">
                            Share a few details and I will reach out shortly.
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-1 rounded-full hover:bg-gray-100 text-gray-500 hover:text-gray-800 transition"
                        aria-label="Close form"
                    >
                        <X size={22} />
                    </button>
                </div>

                {/* Resuable Contact Form */}
                <ContactForm onSubmitSuccess={onClose} borderless={true} />
            </div>
        </div>
    );
}
